import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-111752c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "track-details" }
const _hoisted_2 = { class: "track-details-wrap" }
const _hoisted_3 = {
  class: "t-container",
  style: {"margin-bottom":"150px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "track-details-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "track-details-top__left" }, "详细信息")
], -1))
const _hoisted_5 = { class: "track-details-con" }
const _hoisted_6 = { class: "track-details-item__hd" }
const _hoisted_7 = { class: "track-details-item__bd" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageInfo, (stage, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "track-details-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(stage.title), 1),
              _createElementVNode("ol", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stage.content, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}